import { Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import useDelete from "../../../hooks/useDelete";
import useUser from "../../../hooks/useUser";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export default function DeleteConversation({ handleMenuClose, convoId }) {
  const { profile } = useUser();
  const [searchParams] = useSearchParams();
  const readFilter = searchParams.get("read_f") ?? false;

  const { t } = useTranslation();
  const del = useDelete(
    convoId,
    "/inbox/conversation/",
    ["conversations"],
    "DeleteConvo",
    null,
    ["conversations"]
  );

  const handleDelete = async (e) => {
    e.stopPropagation();
    const res = await del.deleteFn();
    if (res) {
      handleMenuClose();
    }
  };
  return (
    <>
      <Button color="error" onClick={handleDelete} startIcon={<Delete />}>
        {t("Delete")}
      </Button>

      <del.ConfirmationDialog />
    </>
  );
}
